import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.vorlagen-mandant-options';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenVorlagenMandantOptionsEffects {

    VorlagenMandantOptions$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VORLAGEN_MANDANT_OPTIONS),
        mergeMap((x: ac.GetVorlagenMandantOptionsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVorlagenMandantOptions().pipe(
                map((result: any) => {
                    return new ac.GetVorlagenMandantOptionsErfolgreichAction(result, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVorlagenMandantOptionsFehlerAction(error, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VorlagenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VorlagenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VorlagenQueryService);
        }
        return this.service;
    }
}
